import * as angular from "angular";
import {ExportSurveyRequestModel} from "../models/export-survey-request.model";

export class SurveyRequests {

  /* @ngInject */
  constructor(private $survey, private SurveyAPI) {
  }

  getTypes() {
    const api = this.SurveyAPI.actions.getTypes;
    return this.$$call(api, {}, {}, {})
  }

  // getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds, surveyScore?: string) {
  //   const api = this.SurveyAPI.actions.getTotals;
  //   return this.$$call(api, {
  //     from: from, to: to, type: type, branchIds: branchIds,
  //     accountIds: accountIds, agentAccountIds: agentAccountIds, agentIds: agentIds, score: surveyScore, expand: false
  //   }, {}, {})
  // }

  getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds, surveyScore?: string) {
    const api = this.SurveyAPI.actions.getTotals;
    return this.$$call(api, {
      from: from, to: to, type: type, branchIds: branchIds,
      accountIds: accountIds, agentAccountIds: agentAccountIds, agentIds: agentIds, score: surveyScore
    }, {}, {})
  }

  exportData(exportSurveyRequest: ExportSurveyRequestModel, branchIds: string[]) {
    const api = this.SurveyAPI.actions.exportData;
    return this.$$call(api, {branchIds: branchIds}, exportSurveyRequest, {})
  }

  $$call(_apiCall, _params, _data, _options) {
    return this.$survey().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.survey')
  .service('surveyRequests', SurveyRequests);
